import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="app-footer">
            <div className="footer-content">
                <div className="footer-column brand-column">
                    <h2><span className="brand-red">RED</span>Coris™</h2>
                    <p>We are a small game development studio creating the future.</p>
                </div>

                <div className="footer-column social-column">
                    <h3>Follow Us</h3>
                    <div className="social-links ">
                        <a href="https://discord.com/invite/GDhzHFa8VX" className="social-link" aria-label="Discord">
                            <i className="fab fa-discord"></i> Discord
                        </a>
                        {/*
                        <a href="#" className="social-link" aria-label="Twitter">
                            <i className="fab fa-twitter"></i> X
                        </a>
                        <a href="#" className="social-link" aria-label="YouTube">
                            <i className="fab fa-youtube"></i> YouTube
                        </a>
                        <a href="#" className="social-link" aria-label="Steam">
                            <i className="fab fa-steam"></i> Steam
                        </a>
                        /*/}
                    </div>
                </div>

                <div className="footer-column legal-column">
                    <h3>Contact & Legal</h3>
                    <p><strong>Email:</strong> <a className='footer-link' href="mailto:info@redcoris.com">info@redcoris.com</a></p>
                    <p><strong>IC:</strong> 09621148</p>
                </div>

                <div className="footer-column legal-column ">
                    <h3>Games</h3>
                    <p><a className='footer-link' href="https://echoes.redcoris.com/">Echoes of Sin: <span>Confusion</span></a></p>
                </div>
            </div>

            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} RedCoris™. All rights reserved. </p>

                <p>Website created by <a className='footer-link' href="https://myycrosoft.web.app/">myycro</a></p>


                <div className="footer-legal-links">
                    <a href="#!">Privacy Policy</a>
                    <a href="#!">Terms of Service</a>
                    <div className='footer-link'>Version 0.2</div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
